
//langugage imports
import JapanseLang from "./../loc/languages/japanese";
import FrenchLang from "./../loc/languages/french";
import EnglishLang from "./../loc/languages/eng";
import CzechLang from "./../loc/languages/czech";
import DutchLang from "./../loc/languages/dutch";
import GermanLang from "./../loc/languages/german";
import HungarianLang from "./../loc/languages/hungarian";
import ItalianLang from "./../loc/languages/italian";
import PolishLang from "./../loc/languages/polish";
import PortugeseLang from "./../loc/languages/portuguese";
import RussianLang from "./../loc/languages/russian";
import SpanishLang from "./../loc/languages/spanish";
import ukrainian from "./../loc/languages/ukrainian";
import SettingService from "../../services/SettingService";



export interface IAppStringInterface {
  Off: string;
  On: string;
  PropertyPaneDescription: string;
  BasicGroupName: string;
  DescriptionFieldLabel: string;
  AppLocalEnvironmentSharePoint: string;
  AppLocalEnvironmentTeams: string;
  AppSharePointEnvironment: string;
  AppTeamsTabEnvironment: string;
  Home: string;
  Search: string;
  NoDataAvailable: string;
  ShowEntries: string;
  Of: string;
  Enable: string;
  Cancel: string;
  AboveCustomFormisAlreadyExisting: string;
  Ok: string;
  SomethingWentWrong: string;
  LastModifiedOn: string;
  Counterparty: string;
  EffectiveFrom: string;
  HideSideNavigationPanelInSharePointPage: string;
  HideWebPartTitleInSharePointPageWhereAppIsRunning: string;
  WebpartCustomCssdisable: string;
  HideSideNavigationPanelInSharePointPageWhereAppIsRunning: string;
  HideWebPartTitleInSharePointPage: string;
  WebpartCustomCss: string;
  Crop: string;
  BrandLogo: string;
  LightMode: string;
  DarkMode: string;
  SiteTheme: string;
  SideNavigationTheme: string;
  DateFormats: string;
  SaveLogo: string;
  fieldadd: string;
  fieldselect: string;
  sectionadd: string;
  Addnewgroup: string;
  sectionexist: string;
  Form: string;
  Help: string;
  Edit: string;
  Entries: string;
  WordEditor: string;
  Delete: string;
  Update: string;
  Deletemsglevel: string;
  Appmsgall: string;
  Appmsgallnot: string;
  TemplateCon: string;
  contracttypename: string;
  SuccessupdateCustomfiels: string;
  contracttypename1: string;
  Approvaltype: string;
  ApprovalStage: string;
  uploadsuccess: string;
  NewContractForm: string;
  Contract_Type: string;
  uploaderror: string;
  updatedoc: string;
  Contract_End_Date: string;
  Contract_Start_Date: string;
  UserSavedsuc: string;
  Emperrormsg: string;
  Userexist: string;
  RequiredFields: string;
  Administration: string;
  Settings: string;
  PleaseFillTheRequiredFields: string;
  SavedSuccessfully: string;
  Users: string;
  addusers: string;
  Editusers: string;
  Approved: string;
  Draft: string;
  Negotiated: string;
  Alltasks: string;
  TaskName: string;
  RequestType: string;
  DueDate: string;
  Signed: string;
  Active: string;
  Contracts: string;
  Close: string;
  Title: string;
  SystemSetting: string;
  Selcttype: string;
  ContactUs: string;
  Services: string;
  Services1: string;
  ContractEndDate: string;
  TerminationNoticePeriod: string;
  Masteragr: string;
  Ndaagr: string;
  Name: string;
  Description: string;
  Save: string;
  EnterName: string;
  RequesterName: string;
  RequesterDepartment: string;
  CounterpartyPrimary: string;
  ContractTerm: string;
  ContractEffectiveDate: string;
  CounterpartyName: string;
  PrivacyPolicy: string;
  Support: string;
  FAQ: string;
  Newcontract: string;
  ProductActivation: string;
  Pleasewait: string;
  LicenseValidation: string;
  LicenseSuccess: string;
  ErrorToastMessage: string;
  EnterApprover: string;
  SaveApproval: string;
  AddApproval: string;
  Approval_flow_deleted_successfully: string;
  DeleteApprovalFlow: string;
  Category: string;
  Intent: string;
  PartyA: string;
  PartyB: string;
  ApprovalWorkflow: string;
  Newcontracttype: string;
  Saveaspublish: string;
  Saveasdraft: string;
  ContractTypes: string;
  View: string;
  AddApprovaledit: string;
  Parallel: string;
  Sequential: string;
  SingleLineText: string;
  Number: string;
  Choice: string;
  ColumnNameErrorMessage: string;
  SuccessNewFieldMessage: string;
  UpdateNewFieldMessage: string;
  DeleteContracttypedMessage: string;
  DuplicateColumnName: string;
  Add: string;
  ColumnName: string;
  ColumnType: string;
  MultiLine: string;
  FieldsUpdate: string;
  EditColumn: string;
  AddColumns: string;
  Yes: string;
  No: string;
  General: string;
  Additional: string;
  SelectTab: string;
  Select: string;
  CommaSpearate: string;
  Type: string;
  Action: string;
  MyTask: string;
  DueTasks: string;
  NewRequest: string;
  Fieldname: string;
  AddFieldName: string;
  Filter: string;
  Request: string;
  Department: string;
  ExpiringSoon: string;
  Expired: string;
  OverDuetasks: string;
  Completedtasks: string;
  MyoverDuetasks: string;
  formadd: string;
  RequestContract: string;
  Contractformsavedsuccessfully: string;
  Contractformupdatedsuccessfully: string;
  SuccessM365Department: string;
  SaveAndAddMore: string;
  SuccessDepartment: string;
  UpdateDepartment: string;
  DeleteDepartment: string;
  DuplicateDepartment: string;
  DepartmentErrorMessage: string;
  Location: string;
  SuccessM365Location: string;
  SuccessLocation: string;
  UpdateLocation: string;
  DeleteLocation: string;
  DuplicateLocation: string;
  LocationErrorMessage: string;
  SuccessM365Position: string;
  SuccessPosition: string;
  UpdatePosition: string;
  DeletePosition: string;
  DuplicatePosition: string;
  PositionErrorMessage: string;
  SuccessRole: string;
  UpdateRole: string;
  DeleteRole: string;
  DuplicateRole: string;
  RoleErrorMessage: string;
  BusinessUnit: string;
  SuccessBusinessUnit: string;
  UpdateBusinessUnit: string;
  DeleteBusinessUnit: string;
  DuplicateBusinessUnit: string;
  BusinessUnitErrorMessage: string;
  SuccessCounterparty: string;
  UpdateCounterparty: string;
  DeleteCounterparty: string;
  DuplicateCounterparty: string;
  CounterpartyErrorMessage: string;
  SuccessClauseType: string;
  UpdateClauseType: string;
  DeleteClauseType: string;
  DuplicateClauseType: string;
  ClauseTypeErrorMessage: string;
  AddContractFormField: string;
  ContractField: string;
  Operator: string;
  NumberorText: string;
  Condition: string;
  Approver: string;
  Dragthefield: string;
  SuccessCustomfiels: string;
  ListofClauseLanguages: string;
  StandardClause: string;
  AlternativeClauses: string;
  ClauseDetails: string;
  ClauseName: string;
  ClauseType: string;
  ModifiedOn: string;
  CreatedBy: string;
  Tags: string;
  ClauseTitle: string;
  Clause: string;
  AlternateClause: string;
  InsertFields: string;
  Create: string;
  SelectClauseType: string;
  EgTerm: string;
  EgKeywords: string;
  SystemFields: string;
  EnterClauseName: string;
  ClauseNamealreadyexist: string;
  LastModifiedBy: string;
  EditClause: string;
  NewClause: string;
  Country: string;
  State: string;
  City: string;
  Countryp: string;
  Statep: string;
  Cityp: string;
  Licencevalidation: string;
  ContractFormSection: string;
  Editdepartment: string;
  Adddepartment: string;
  Position: string;
  Addposition: string;
  Addlocation: string;
  editrole: string;
  Addrole: string;
  Role: string;
  editbussinessunit: string;
  Addbussinessunit: string;
  Addclausetype: string;
  editcounterparty: string;
  Addcounterparty: string;
  EnterManagerName: string;
  EntersectionName: string;
  counterpartyType: string;
  EnterDepartment: string;
  EnterPosition: string;
  EnterLocation: string;
  EnterRole: string;
  EnterBusinessUnit: string;
  EnterClauseType: string;
  EnterCounterpartyType: string;
  Addmultcon: string;
  RequestDraft: string;
  Hidetopcommandbar: string;
  Hidetopcommandbartooltip: string;
  attachment: string;
  totalappusers: string;
  StandardTemplate: string;
  NewRequestForm: string;
  activity: string;
  AddActivity: string;
  editActivity: string;
  activityupdated: string;
  successactivity: string;
  DeleteActivity: string;
  Origninator: string;
  ToAssigned: string;
  OnHold: string;
  OtherActions: string;
  DueDays: string;
  OnRejection: string;
  msgerrorcontype: string;
  msgerrorzip: string;
  msgerrorcsv: string;
  AllowTaskOwnerToEdit: string;
  AllowTaskOwnerToHold: string;
  CompleteTheTaskWithIn: string;
  days: string;
  PostRejectionRedirect: string;
  AttachmentType: string;
  AttachmentName: string;
  Enterremark: string;
  Download: string;
  Publish: string;
  DocumentName: string;
  DocumentType: string;
  DraftType: string;
  DraftName: string;
  CreatedOn: string;
  DraftUpload: string;
  Requestformsavedsuccessfully: string;
  Draftformsavedsuccessfully: string;
  Requestformupdatedsuccessfully: string;
  Duplicatefield: string;
  Expringsoon: string;
  RequestNumber: string;
  ContractNumber: string;
  BusinessCode: string;
  EnterBusinesscode: string;
  enterContractCode: string;
  enterbusinessunitcode: string;
  VersionNo: string;
  Date: string;
  request_No: string;
  contract_No: string;
  draft_No: string;
  Attachments: string;
  Request_Number: string;
  Contract_Number: string;
  OverDueDays: string;
  DropYourFileHere: string;
  AmdReq: string;
  TaskStage: string;
  RequestApproval: string;
  DraftApproval: string;
  AddRequestAction: string;
  EditRequestAction: string;
  SavedSuccessFully: string;
  RequestStage: string;
  DuplicateActivity: string;
  Approvalflowaddedsuccesfully: string;
  UpdateApproval: string;
  MyTasks: string;
  Actions: string;
  RequestAction: string;
  Export: string;
  ContractReport: string;
  RequestReport: string;
  To: string;
  SetingsSuccessmessage: string;
  Logosuccessmessage: string;
  Optional: string;
  EndDateMessage: string;
  SelectRequestType: string;
  SelectBusinessUnit: string;
  SelectDraftType: string;
  Contract: string;
  Downloadsamplefile: string;
  ImportFile: string;
  Upload: string;
  ZipFolder: string;
  Instructions: string;
  Addmultiplerecords: string;
  SelcectcontracttypeandclickDownload: string;
  PleaseuploadpdffilefromZipFolder: string;
  PleaseuseMM_DD_YYYYformat: string;
  PleasedontAddCommas: string;
  PleasedontChangeOrderofcolumns: string;
  ContractName: string;
  ContractCode: string;
  BusinessUnitCode: string;
  AreUsurewanttoDelete: string;
  AddContractType: string;
  ConfigureConditionalField: string;
  Note_TomakefieldMandatory: string;
  EditContracttype: string;
  AddEditUsers: string;
  AdvancePermissions: string;
  Integrations: string;
  Phone: string;
  CLM365MailBox: string;
  ContractFields: string;
  AddCustomFields: string;
  Features: string;
  HideWebparttitle: string;
  HideNavigationpanel: string;
  GeneralSettings: string;
  Color: string;
  DisplayResolvedTab: string;
  Feature: string;
  Note_PleaseUploadlogo: string;
  UploadLogo: string;
  Dropyourfiles: string;
  Pleaseattachfile: string;
  Counterpartysuccessmessage: string;
  Error: string;
  Selectfile: string;
  Editcontract: string;
  FielMandatoryError: string;
  AltestFieldRequired: string;
  PleaseaddsectionName: string;
  SectionNameAlreadyExit: string;
  deleteContractType: string;
  Formsavedsuccessfully: string;
  SectionExists: string;
  AddsectionName: string;
  ThisFieldisRequired: string;
  TaskTitle: string;
  Business_User: string;
  LegalHead: string;
  SelectLegalHead: string;
  SelectBusinessName: string;
  InApproval: string;
  LegalReview: string;
  Negotiation: string;
  Waitingforexecution: string;
  ExecutionApproval: string;
  TeamsCLM365PhoneNumber: string;
  PleaseEnterthePhoneNumber: string;
  AddPhone: string;
  EditPhone: string;
  Teams: string;
  Submit: string;
  DeleteAlertMessage: string;
  DeletedSuccessfully: string;
  AddedSuccessfully: string;
  UpdatedSuccessfully: string;
  DeleteAlertMessagemailbox: string;
  MailboxManager: string;
  Tasks: string;
  Mandatory: string;
  Contractsuploadsuccess: string;
  Deletedepartmentwarning: string;
  Deletepositionwarning: string;
  DeleteLocationwarning: string;
  DeleteRolewarning: string;
  DeleteBusinessunitwarning: string;
  DeleteClausetypeWarning: string;
  DeleteCounterpartywarning: string;
  Deletelibrarywarning: string;
  Deleteuserwarning: string;
  Userdeletedsuccessfully: string;
  pleaseenterthevalue: string;
  Mandatoryfield: string;
  Obligation: string;
  EnterObligation: string;
  ObligationCategory: string;
  ObligationCategoryEnter: string;
  AddObligation: string;
  editObligation: string;
  UpdateObligation: string;
  SuccessObligation: string;
  UpdateObligationCategory: string;
  SuccessObligationCategory: string;
  AddObligationC: string;
  editObligationC: string;
  selectcontracttype: string;
  selectTasktype: string;
  selectObligationCategory: string;
  Tasktype: string;
  SelectFrequency: string;
  Frequency: string;
  ObligationErrorMessage: string;
  ObligationCErrorMessage: string;
  Sequence: string;
  Configure: string;
  ContractSequence: string;
  RequestSequence: string;
  Next: string;
  ContractandRequestNumber: string;
  ContractNumberseq: string;
  RequestNumberseq: string;
  AddRequestNumber: string;
  EditRequestNumber: string;
  AddContractNumber: string;
  EditContractNumber: string;
  RequestNumberAdded: string;
  RequestNumberUpdated: string;
  RequestNumberDeleted: string;
  ContractNumberAdded: string;
  ContractNumberUpdated: string;
  ContractNumberDeleted: string;
  AssignedToUser: string;
  Processing: string;
  SyncDepartmentfromM365: string;
  SyncPositionfromM365: string;
  SyncLocationfromM365: string;
  ModifiedBy: string;
  CombinationAlreadyExist: string;
  ObligationTitle: string;
  Priority: string;
  ObligationOwner: string;
  Status: string;
  Deleteobligationwarning: string;
  DeleteObligation: string;
  Enterbusinessunit: string;
  Enterbusinesscode: string;
  DeleteContractnumberwarning: string;
  DeleteRequestnumberwarning: string;
  Deleteobligationcategorywarning: string;
  DleteObligationcategory: string;
  OrganizationName: string;
  Email: string;
  Counterpartyupdatesuccessmessage: string;
  Execution: string;
  Owner: string;
  Preview: string;
  AutoNumbering: string;
  ContractNumbering: string;
  RequestNumbering: string;
  EditRequestNumbering: string;
  EditContractNumbering: string;
  selectreasonType: string;
  ReasonErrorMessage: string;
  Enterreason: string;
  DuplicateReason: string;
  SuccessReason: string;
  Updatereason: string;
  Deletereason: string;
  editReason: string;
  AddReason: string;
  TitleRequired: string;
  BusinessUnitRequired: string;
  ContractTypeRequired: string;
  ObligationCatRequired: string;
  PriorityRequired: string;
  TaskTypeRequired: string;
  StatusRequired: string;
  RequestActionDeleted: string;
  getConfirmationToDeleteRequestAction: string;
  DeleteReasonWarning: string;
  Theme: string;
  SuccessmessagePostdata: string;
  From: string;
  HideTopSiteHeader: string;
  HideCommentsWrapper: string;
  HideTopSiteHeaderInSharePointPage: string;
  HideTopSiteHeaderInSharePointPageWhereAppIsRunning: string;
  HideCommentsWrapperInSharePointPage: string;
  HideCommentsWrapperInSharePointPageWhereAppIsRunning: string;
  Businessuser: string;
  Businessusermanager: string;
  Businessusermanagermanager: string;
  EmployeeName: string;
  Successmessageadditionaltask: string;
  EmailTemplate: string;
  AddTemplate: string;
  EditTemplate: string;
  Template: string;
  Notifications: string;
  DaysBefore: string;
  TemplateType: string;
  Selectanoption: string;
  EmailSubject: string;
  EmailBody: string;
  EnterEmailSubject: string;
  Reminder: string;
  EnterEmailBody: string;
  EmailTemplates: string;
  ObligationCategories: string;
  Publishsuccessmessage: string;
  SelectRejectionReasons: string;
  AddBulk: string;
  EmailSubjectExist: string;
  Confirm: string;
  Terminated: string;
  InProgress: string;
  DeleteEmailtemplatewarning: string;
  Pleaseaddcorrectfiletypecsvorxlsorxlsx: string;
  Pleaseimportthecorrectcolumnsfromthesamplefile: string;
  Actioncompletedsuccessfully: string;
  Pleaseattachafile: string;
  ImportSampleFile: string;
  PleaseremovecommasfromnoteoranyotherfieldstoavoidconflictswithcommasofCSVfile: string;
  MandatoryfieldslikeCompanyNameshouldnotbeempty: string;
  SelectApprovalStage: string;
  LegalReviewIsMandatory: string;
  PublishIsMandatory: string;
  ApproversName: string;
  TaskTitleToolTip: string;
  Deletewarningcondition: string;
  Website: string;
  OrganizationTitle: string;
  RejectionReasons: string;
  RejectionReasonstitles: string;
  Reasons: string;
  ReasonsTerminationwidraw: string;
  Youcanskiorchangeexecution: string;
  Language: string;
  DefaultBrowserLanguageText: string;
  TextForDropdownLanguage: string;
  JobTitle: string;
  OrganizationInfo: string;
  ActivityLog: string;
  ClauseLibrary: string;
  UsersRolesAndPermissions: string;
  ClickOnTheAttachmentIconToAddMultipleAttachments: string;
  ClickOnTheAttachmentIconToAddDraftAttachments: string;
  EditConditionBasedDescription: string;
  MailBoxText: string;
  ThemeSwitchDescription: string;
  DepartmentText: string;
  UpdateUsersProfile: string;

  WorkflowName: string;
  ApprovalType: string;
  SelectApprovers: string;
  SelectDepartment: string;
  SelectJobTitle: string;
  SelectLocation: string;
  EmployeeManager: string;
  SelectRole: string;
  ZipCode: string;
  AddressLine1: string;
  AddressLine2: string;
  OrganizationURL: string;
  Currency: string;
  ContactNumber: string;
  UserEmployeeName: string;
  OrganizationJurisdiction: string;
  EmployeeEmail: string;
  ActiveDays: string;
  EnterWorkflowName: string;
  EnterDescription: string;
  SelectContractTypes: string;
  SelectTitle: string;
  Approvers: string;
  AddApprovers: string;
  SelectConditions: string;
  SkipL1: string;
  SkipL2more: string;
  SelectContractFields: string;
  SelectOperator: string;
  EnterNumberorText: string;
  AddNextLevel: string;
  Complete: string;
  AddConditions: string;
  SelectUsers: string;
  SelectOption: string;
  Requesteris: string;
  Requesterjobtitleis: string;
  Entername: string;
  Requesterdepartmentis: string;
  AddCounterparty: string;
  SelectCounterpartyType: string;
  EditCounterparty: string;
  AddOrganizationInfo: string;
  EditOrganizationInfo: string;
  EnterActivity: string;
  DescriptionSubject: string;
  Placeholder: string;
  Obligations: string;
  SendTo: string;
  Admin: string;
  ContractOwner: string;
  ContractOwnerManager: string;
  AddNewField: string;
  Version: string;
  LicenseType: string;
  Validtill: string;
  Report: string;
  Nodataavailable: string;
  BulkContract: string;
  Values: string;
  Choices: string;
  ConditionField: string;
  SelectContractOwner: string;
  ActivityHistory: string;
  EditRequest: string;
  Reject: string;
  Approve: string;
  Remarks: string;
  Expand: string;
  CounterpartyDetails: string;
  ContractDetails: string;
  RequestAdditionalReview: string;
  Clicktoviewatachments: string;
  VersionHistory: string;
  UpdateSubmit: string;
  CreatedDate: string;
  ContractDate: string;

  Attachment: string;
  UploadDraft: string;
  WithdrawRequest: string;
  SelectReasons: string;
  Selectcounterparty: string;
  SendforLegalReview: string;
  SendbacktoBusinessUser: string;
  WithdrawNegotiation: string;
  businessUnitalradyinuse: string;
  ContractTypeUsed: string;
  EditLocation: string;
  Contractypeexits: string;
  invaliddata: string;
  RowNo: string;
  Message: string;
  invalidemail: string;
  pleasefillcounterparty: string;
  smOrganizationName:string;
  smcounterpartyType:string;
  smEmail:string;
  smCountry:string;
  smContactNumber:string;
  smOrganizationJurisdiction:string;
  RequestSubmittedMessage:string;
  RequestURL:string;
  ContractURL:string;
  EnterEmail:string;
  ReleaseNotes: string;
  EnterValue:string;
  Conditions:string;
  SelectConditionFields:string;
  AssignedTo:string;
  ObligationFiled:string;
  updateclausetype:string;
  SaveasDraft:string;
  AddCustomcolumn:string;
  EnableBusinessUnit:string;
  Homedashboardmulticolortheme:string;
  TooltipMulticolortiles:string;
  EditFieldName:string;
  SelecttheConditionField:string;
  Pleaseselecttheconditionfield:string;
  AddNewCondition:string;
  EditCondition:string;
  Areyousureyouwanttodeletethissection:string;
  ViewBusinessUser:string;
  EditUploaddraft:string;
  Reports:string;
  EnterJobTitle:string;
  Validate:string;
  ConditionUpdatedSuccessfully:string;
  Pleaseentervalue:string;
  Conditionsavedsuccessfully:string;
  Thisfieldismandatoryyoucantchange:string;
  AddTerm:string;
  Term:string;
  Pleaseenteremail:string;
  Editsectionname:string;
  Sectionnamealreadyexists:string;
  Pleseentersectionname:string;
  RequestContractName:string;
  EnableGCCTenant:string;
  GCCTenantTooltip:string;
  DragtheFieldsintoContractForm:string;
  DragtheFields:string;
  Entertemplatename:string;
  Templatenamealreadyexist:string;
  Counterpartyalreadyexists:string;
  Userspropertiessyncedsuccessfully:string;
  TooltipToUpdateUserProperties:string;
  SyncingfromM365:string;
  Pleaseattachcontractfile:string;
  SyncFromM365:string;
  Counterpartytypealreadyusedyoucantdelete:string;
  Counterpartyalreadyusedyoucantdelete:string;
  Enablefavoriteicon:string;
  Pleasedownloadtheabovesamplefile:string;
  ShowfaviconofCLM365:string;
  AttachmentsHome:string;
  Sendto:string;
  CC:string;
  ActivityNotification:string;
  Reason:string;
  Pleasewaitsearch:string;
  azureopenai:string;
  addEditGroup:string;
  DocuSign:string;
  Dashboard:string;
  Inactive:string;
  AddGroup:string;
  EnterGroupName:string;
  AzureOpenAiIntegration:string;
  AzureAiEndpoint:string;
  AzureAiApiKey:string;
  AzureAiDeploymentName:string;
  Subjectformailbody:string;
  BulkCounterparty:string;
  SupportingDocument:string;
  AddDocumentType:string;
  ContractsByMonth:string;
  ContractsByBusinessUnit:string;
  ContractsByAssignee:string;
  ContractsByStatus:string;
  ContractsByContractType:string;
  Enteraiapiurl:string;
  Enterdeploymentname:string;
  Enterazurekey:string;
  Enterendpoint:string;
  Showsampledashboarddata:string;
  HideSideNavbar:string;
  DocuSignRSAPrivateKey:string;
  DocuSignAccountURL:string;
  DocuSignUserID:string;
  DocuSignClientID:string;
  DocuSignAPIURL:string;
  EnterDocuSignClientID:string;
  EnterDocuSignUserID:string;
  Task:string;
  AddRow:string;
  ContractTypesbyStatus:string;
  Requestsagingchart:string;
  RequestsbyMonth:string;
  RequestsbyAssignee:string;
  RequestsbyStatus:string;
  RequestsbyBusinessUnit:string;
  UserGroups:string;
  Selectgroup:string;
  Editgroup:string;
  SelectDecumenttype:string;
  Editdocumenttype:string;
  Renewal:string;
  Amendment:string;
  RequestsbyContractType:string;
  ExpiringContracts:string;
  AllItems:string;
  CurrentWeek:string;
  LastWeek:string;
  CurrentMonth:string;
  LastMonth:string;
  DeleteUsertaskasign:string;
  PleaseSelectUser:string;
  BusinessUnitEnableDisableTooltip:string;
  faviconTooltip:string;
  AzureAiTooltip:string;
  SelectPriority:string;
  EnterDocumenttype:string;
  EnterClumnName:string;
  Sendmessage:string;
}

const switchLanguage = () => {
  switch (SettingService.GetUserLanguage()) {
    case "Czech":
      return CzechLang;
    case "Dutch":
      return DutchLang;
    case "English":
      return EnglishLang;
    case "French":
      return FrenchLang;
    case "German":
      return GermanLang;
    case "Hungarian":
      return HungarianLang;
    case "Italian":
      return ItalianLang;
    case "Japanese":
      return JapanseLang;
    case "Polish":
      return PolishLang;
    case "Japanese":
      return JapanseLang;
    case "Portuguese":
      return PortugeseLang;
    case "Russian":
      return RussianLang;
    case "Spanish":
      return SpanishLang;
    case "Ukrainian":
      return ukrainian;
    default:
      return EnglishLang;
  }
};

const switchBrowserLanguage = () => {
  switch (window.navigator.language) {
    case "cs":
      return CzechLang;
    case "nl":
      return DutchLang;
    case "en-US":
      return EnglishLang;
    case "fr":
      return FrenchLang;
    case "de":
      return GermanLang;
    case "hu":
      return HungarianLang;
    case "it":
      return ItalianLang;
    case "ja":
      return JapanseLang;
    case "pl":
      return PolishLang;
    case "pt":
      return PortugeseLang;
    case "ru":
      return RussianLang;
    case "es":
      return SpanishLang;
    case "uk":
      return ukrainian;
    default:
      return EnglishLang;
  }
}

// initialize the language content
// checks if there is browser default langugage enabled if yes then switch to broswer default language or else choose the language given in the dropdown (user prefered language)

export const updateString = () => {
  return SettingService.GetIsBrowserDefaultLangaugeEnabled() == 'true' ? switchBrowserLanguage() : switchLanguage();
}

class LanguageModal {
  private stringContent: IAppStringInterface;
  private stringContent2: IAppStringInterface;
  constructor(stringContent: IAppStringInterface) {
    this.stringContent = Object.assign({},  stringContent);
    this.stringContent2 = Object.assign({},  stringContent);
  }

  getLanguageOldContent() {
    return this.stringContent
  }
  // returns the updated language content always!
  getLanguageContent() {
    let mData=SettingService.getLanguageData();
    let curLang=SettingService.GetUserLanguage();
    // let stringContent2 = Object.assign({},  this.stringContent);
    if(curLang){
      Object.keys(JSON.parse(mData)[curLang]).map((k)=>{
        this.stringContent2[k]=JSON.parse(mData)[curLang][k];
      })
    }
    return this.stringContent2;
  }

  // updated the language based on the SettingSerive condition
  updateLanguageContent() {
    this.stringContent2 = Object.assign({}, updateString());
    return this.stringContent = Object.assign({}, updateString());
  }
}
export const languageModal = new LanguageModal(updateString());